import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaEliminarConfirmar', {
    template: template,
    controller: NominasNominaEliminarConfirmarComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      onClose: '&',
    },
  })

function NominasNominaEliminarConfirmarComponent($state, NominasNomina) {
  let $ctrl = this

  $ctrl.aceptar = aceptar
  $ctrl.cerrar = cerrar
  $ctrl.completado = false
  $ctrl.eliminar = eliminar
  $ctrl.error = null
  $ctrl.procesando = false

  function aceptar() {
    $state.go('dashboard')
  }

  function eliminar() {
    if ($ctrl.procesando)
      return

    $ctrl.completado = false
    $ctrl.error = null
    $ctrl.procesando = true

    NominasNomina.delete($ctrl.idProyecto, $ctrl.idNomina)
      .then(function () {
        $ctrl.completado = true
      })
      .catch(function (response) {
        $ctrl.error = response.data
      })
      .finally(function () {
        $ctrl.procesando = false
      })
  }

  function cerrar() {
    $ctrl.onClose()
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/eliminar/confirmar/component.js